<template>
    <dropdown-filter
        @change="$emit('input', $event)"
        :value="value"
        label="Filter by Gender"
        :options="genders"
    />
</template>

<script>
import $fetch from 'wee-fetch';
import DropdownFilter from '../dropdown-filter/index.vue';

export default {
    components: {
        DropdownFilter,
    },
    props: {
        value: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        genders: [{
            key: 'Both',
            value: 'Both'
        }, {
            key: 'Male',
            value: 'Male'
        }, {
            key: 'Female',
            value: 'Female',
        }],
    }),
}
</script>
